import { createContext, useCallback, useContext, useMemo, useState } from "react";

const EnquiryContext = createContext(null);

export function EnquiryProvider({ children }) {
  const [state, setState] = useState(null);
  const openEnquiry = useCallback((type = "advisor", preset = {}) => setState({ type, preset, source: window.location.pathname }), []);
  const closeEnquiry = useCallback(() => setState(null), []);
  const value = useMemo(() => ({ enquiry: state, openEnquiry, closeEnquiry }), [state, openEnquiry, closeEnquiry]);
  return <EnquiryContext.Provider value={value}>{children}</EnquiryContext.Provider>;
}

export const useEnquiry = () => useContext(EnquiryContext);
